import React from "react";
import PreStartPreviewNav from "./PreStartPreviewNav";
import JobShiftPreStartViewHeader from "../../JobShiftPreStart/JobShiftPreStartViewHeader";
import PreStartDetails from "../../JobShiftPreStart/sections/PreStartDetails";
import PreStartQuestionsPreview from "./PreStartQuestionsPreview";
import FlaggedIncorrectiveQuestionsPreview from "./FlaggedIncorrectiveQuestionsPreview";
import PreStartSignOffPreview from "./PreStartSignOffPreview";
import styles from "./PreviewV3.module.css";

export default function PreStartPreviewLayout({ swmsNumber, sections, preStartChecklist, approvalStatus }) {
  return (
    <div className={styles.PreviewWrap}>
      <PreStartPreviewNav swmsNumber={swmsNumber} />
      <main>
        <div className={styles.PreviewDoc}>
          <JobShiftPreStartViewHeader sections={sections || {}} preStartData={{}} rightClassName="preview-prestart-header-right" />
          <div id="prestart-sec-details" className={styles.PreviewSectionAnchor}>
            <PreStartDetails
              sections={sections || {}}
              preStartData={{ status: approvalStatus }}
              previewMode
            />
          </div>
          <div id="prestart-sec-questions" className={styles.PreviewSectionAnchor}>
            <PreStartQuestionsPreview preStartChecklist={preStartChecklist} />
          </div>
          <div id="prestart-sec-flagged" className={styles.PreviewSectionAnchor}>
            <FlaggedIncorrectiveQuestionsPreview />
          </div>
          <div id="prestart-sec-signoff" className={styles.PreviewSectionAnchor}>
            <PreStartSignOffPreview preStartChecklist={preStartChecklist} />
          </div>
        </div>
      </main>
    </div>
  );
}
